<template>
    <div class="ExitSimulatorPage">
        <div class="ExitSimulatorPage__wrapper">

            <a 
                :href="baseUrl" 
                title="Retourner sur le site monchauffagisteprivé"
                class="ExitSimulatorPage__logo"
            >
                <SvgLogoMcp
                    width="285"
                    height="62"
                />
            </a>
            
            <svg
                v-svg
                symbol="Equipe_proxi"
                size="0 0 420 230"
                role="presentation"
                class="icon--inline Icon-Equipe_proxi ExitSimulatorPage__svg"
            ></svg>

            <div v-html="content[contentToDisplay].html" class="ExitSimulatorPage__status-message"></div>

            <div class="ExitSimulatorPage__cta-container">
                <button 
                    v-if="content[contentToDisplay].primaryBtn"
                    class="btn btn--red btn--fill btn-primary_chevron"
                    :class="content[contentToDisplay].primaryLabel === 'Easy-entretien' ? 'btn-ee' : '' "
                    @click="content[contentToDisplay].primaryAction"
                >
                    <span class="btn-label">{{ content[contentToDisplay].primaryLabel }}</span>
                    <i class="icon-arrow-2"></i>
                </button>

                <a :href="baseUrl" class="home-link">Retourner sur le site monchauffagisteprivé</a>
            </div>

        </div>
    </div>
</template>

<script>
import SvgLogoMcp from '@/components/SvgAnimated/Logos/SvgLogoMcp.vue'

import EventBus from "@/event-bus";
import { mapGetters } from "vuex";


export default {
    name: "ExitSimulatorPage",

    components: { 
        SvgLogoMcp,
    },

    props: {
        contentToDisplay: {
            type:String,
            default: "success",
        }
    },

    computed: {
        ...mapGetters({ 
            currentStep: "getCurrentStep",
            savingFormAnswers: "getSavingOptionsAnswers"
        }),
    },

    data() {
        return {
            baseUrl: process.env.VUE_APP_API_BASE_URL,
            mediaBaseUrl: `${process.env.VUE_APP_API_BASE_URL}/skin/frontend/mcp/default/images/`,
            content: {
                aids_failure: {
                    html: `<p>Malheureusement, vous ne remplissez pas les conditions pour obtenir les aides.</p>`,
                    primaryBtn: true,
                    primaryLabel: 'Recommencer',
                    primaryAction: () => this.retrySimulator(),
                    gtmEvent: 'gtm-endJourney::push',
                },
                ownership: {
                    html: `<p class="smallText-container">Malheureusement, vous ne remplissez pas les conditions pour obtenir les aides. <br><small>Nous pouvons cependant vous proposer l'entretien de votre chaudière.</small></p>`,
                    primaryBtn: true,
                    primaryLabel: 'Easy-entretien',
                    primaryAction: () => this.redirectToUrl('https://www.easy-entretien.com/'),
                    gtmEvent: 'simulatorAdvanced-error_ownerConsent',
                },
                zipcode_failure: {
                    html: `<p>Malheureusement, votre code postal n'est pas éligible.</p>`,
                    primaryBtn: false,
                    primaryLabel: 'Recommencer',
                    primaryAction: () => this.retrySimulator(),
                    gtmEvent: 'gtm-endJourney::push'
                },
                midStep: {
                    html: `<p class="redText smallText-container">Merci pour votre demande ! <br><small>Notre équipe Proxiserve revient vers vous dans les plus bref délais.</small></p>`,
                    primaryBtn: true,
                    primaryLabel: 'Calculez mes aides',
                    primaryAction: () => this.launchAidStep(),
                    gtmEvent: 'gtm-thankYou::push'
                },
                success: {
                    html: `<p class="redText">Merci pour votre demande ! <br><small>Notre équipe Proxiserve revient vers vous dans les plus bref délais.</small></p>`,
                    primaryBtn: false,
                    gtmEvent: 'gtm-thankYou::push'
                }
            },
            
        };
    },

    methods: {
        /**
         * Clear and restart simulator
         */
        retrySimulator() {
            location.reload(); // restart from begin and clear all store
        },

        redirectToUrl(url) {
            window.location.href = url;
        },

        /**
         * begin aids form after Resume Pages
         */
        launchAidStep() {
            EventBus.$emit("stepAction::validate", 'save_energy');
            EventBus.$emit("simulator-page::tunnel", 'aids');
        },

        /**
         * Handle display aids calculation btn
         */
        handlePrimaryAidButton() {
            return this.savingFormAnswers.isAidsEligible;
        },

        /**
         * Change zicode faillure content 
         * according to steps
         */
        handleZipCodeFaillureContent() {
            if(this.contentToDisplay == 'zipcode_failure' ) {
                this.content.zipcode_failure.html = this.currentStep == 'save_energy' ?
                    `<p>Malheureusement, votre code postal n'est pas éligible pour ${this.savingFormAnswers.mcp_customer_heating_equipment_name}</p>` :
                    "<p>Malheureusement, votre code postal n'est pas éligible.</p>";
            }
        },

    },

    created() {
        this.content.midStep.primaryBtn = this.handlePrimaryAidButton();
        this.handleZipCodeFaillureContent();

        //Gtm-event
        EventBus.$emit(this.content[this.contentToDisplay].gtmEvent);
    },

    
}
</script>

<style lang="scss">
.ExitSimulatorPage {
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;

    &::-webkit-scrollbar{
    display: none;
  }
    

    &__wrapper {
        max-width: 640px;
        text-align: center;
    }
    
    &__logo {
        display: inline-block;
        margin-bottom: 60px;
        
        @include breakpoint(md) {
          margin-bottom: 100px;
        }

        img {
          max-width: 200px;

          @include breakpoint(md) {
            max-width: 300px;
          }
        }
      
    }

    &__svg {
        max-width: 80%;
    }

    &__status-message {
        margin: 5vh auto;
        
        p {
            font-size: 1.8rem;
            line-height: 1.1;
            color: $c-grey-dark;
            font-family: $font-family-normal;
            font-weight: $fw-robotoM;

            &.smallText-container {
                small {
                    color: $c-grey-dark;
                    font-size: 2rem;
                }
            }

            &.redText {
                color: $c-mcp-red;
            }
        } 
    }

    &__cta-container {
        button,
        a {
            margin: 10px auto;
        }

        button.btn-ee {
            background: #ef604e;
            border-color: #ef604e;
            box-shadow: 4px 4px 10px rgba(239, 96, 78, 0.349);

            i {
                width: 20px;
                height: 20px;
                background: url(../../assets/icons/mcp/Ee-logoWhite.svg);

                
                &::before {
                    content: '';
                } 
            }

            &:hover {
                i {
                    background: url(../../assets/icons/mcp/Ee-logo.svg);
                }     
            }
        }
    }

    
}

.ExitSimulatorPage{
    
    @include breakpoint(md) {
        &__status-message {
            p {
               font-size: 3rem; 
            }
        }

        &__cta-container {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;

            button,
            a {
                margin: 0;
            }
        }
    }
}

</style>